import React from "react";
import { Link } from "gatsby";
import Container from "./container";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import PortableText from "./portableText";
import Icon from "./icon";

import * as styles from "../styles/components/fc-content-with-image.module.css";

const ContentWithImage = (props) => {

  const {
    _key,
    title,
    _rawSubtitle,
    _rawContent,
    button,
    image
  } = props;

  return (
    <div className={styles.root} key={_key}>
      <div className={cn("grid", styles.grid)}>
        <div className={cn("col-12 col-md-8", styles.text)}>
          <div className={styles.contentWrap}>
            {_rawSubtitle && (<div className={styles.subtitle}><PortableText blocks={_rawSubtitle} /></div>)}
            {title && (<h2 className={cn(styles.title, "color-palette-color")}>{title}</h2>)}
            {_rawContent && (<div className={cn("entry-content", styles.content)}><PortableText blocks={_rawContent} /></div>)}
            {button && button.url && (
              <>
                {button.blank ? (
                  <a href={button.url} className={cn("btn", button.secondaryButton ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke" : "color-palette-pseudo-bg")} target="_blank" rel="noreferrer">
                    {button.text}
                    <Icon symbol="arrow-right" />
                  </a>
                ) : (
                  <Link to={button.url} className={cn("btn", button.secondaryButton ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke" : "color-palette-pseudo-bg")}>
                    {button.text}
                    <Icon symbol="arrow-right" />
                  </Link>
                )}
              </>
            )}
          </div>
        </div>
        <div className={cn("col-12 col-md-4", styles.image)}>
          {image && image.asset && (
            <img
              src={imageUrlFor(buildImageObj(image))
                .auto("format")
                .url()}
              alt=""
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ContentWithImage;
